import React from "react";
import { Link } from "react-router-dom";
import { PageIntro } from "../components/PageIntro";
import { LedgerIndex } from "../components/ledger/LedgerIndex";
import { ClosingCTA } from "../components/ClosingCTA";
import { ledgerArticles } from "../data/ledger";
import { photos } from "../data/photography";
export function Ledger() {
  const lead = ledgerArticles.find(a => a.featured) ?? ledgerArticles[0];
  return <>
      <PageIntro label="The Ledger" title="Payroll operations and HR technology, examined from the inside." statement="Constant’s ongoing publication — essays, field notes, and analysis from the people who do the work." data-id="element-794" data-mp="2vk0z6qsk34z8" />

      <section aria-label="Featured" className="border-y border-stone" data-id="element-795" data-mp="2qm7pvovyhuuq">
        <div className="shell grid grid-cols-12 gap-x-6 gap-y-12 py-16 md:py-20" data-id="element-796" data-mp="2qk4s2iokaxfg">
          <article className="col-span-12 lg:col-span-7 lg:border-r lg:border-stone lg:pr-12" data-id="element-797" data-mp="2cnhtkbgynz7f">
            <div className="mb-10 aspect-[3/2] overflow-hidden bg-stone" data-id="element-798" data-mp="2hl18ldlhgg0f">
              <img src={photos.ledgerBook.src} alt={photos.ledgerBook.alt} className="h-full w-full object-cover" data-id="element-799" data-mp="o8x04scgd8z4" />
            </div>
            <p className="text-xs tracking-[0.08em] text-charcoal/65" data-id="element-800" data-mp="jczo2y882os5">
              <span className="font-semibold text-oxblood" data-id="element-801" data-mp="x9d74bsemy8q">{lead.topic}</span> · {lead.format} · {lead.date} ·{" "}
              {lead.readTime}
            </p>
            <h2 className="mt-6 font-display text-[clamp(2.25rem,4.4vw,3.75rem)] leading-[1.05] text-navy" data-id="element-802" data-mp="4lpmiwr4w7m3">
              {lead.title}
            </h2>
            <p className="mt-6 max-w-xl text-lg leading-relaxed text-charcoal/80" data-id="element-803" data-mp="m8hu5jj7ehz">{lead.dek}</p>
          </article>

          <aside aria-labelledby="from-research" className="col-span-12 lg:col-span-4 lg:col-start-9" data-id="element-804" data-mp="edvfa8p7mt2c">
            <div className="border-2 border-oxblood p-8" data-id="element-805" data-mp="9j92c13hcsg5">
              <p className="eyebrow text-oxblood" data-id="element-806" data-mp="3hzkmvyqptmfo">From Research & Intelligence</p>
              <h2 id="from-research" className="sr-only" data-id="element-807" data-mp="3d2kf9je7wbmg">
                Featured research
              </h2>
              <ul className="mt-6" data-id="element-808" data-mp="1gxml2zjm7v9p">
                <li className="border-b border-stone pb-5" data-id="element-809" data-mp="1gwjrgjuwreq3">
                  <Link to="/research#state-of-payroll" className="font-display text-2xl leading-snug text-navy hover:text-oxblood" data-id="element-810" data-mp="1lwpefmq8gd1u">
                    The State of Payroll Operations, 2026
                  </Link>
                </li>
                <li className="pt-5" data-id="element-811" data-mp="1vpmy3w6yo821">
                  <Link to="/research#maturity-model" className="font-display text-2xl leading-snug text-navy hover:text-oxblood" data-id="element-812" data-mp="y0bib4yryjpi">
                    The Payroll Maturity Model™
                  </Link>
                </li>
              </ul>
              <p className="mt-6 text-sm leading-relaxed text-charcoal/70" data-id="element-813" data-mp="17wen6il0gwg5">
                Proprietary research lives with Research & Intelligence. The Ledger is where we discuss it.
              </p>
            </div>
          </aside>
        </div>
      </section>

      <LedgerIndex data-id="element-814" data-mp="2ndyl765zzn7x" />
      <ClosingCTA data-id="element-815" data-mp="2ndezrfh52gp5" />
    </>;
}